import { DateTime, Interval } from "luxon";

function fromJson(e) {
  return {
    name: e.name,
    id: e.id,
    details: e.details,
    start: DateTime.fromISO(e.start),
    end: DateTime.fromISO(e.end)
  };
}
export default {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    create({ commit, state }, { email, firstName, lastName, password }) {
      commit("loading", true, { root: true });
      return flink.user
        .create({
          email: email,
          firstName: firstName,
          lastName: lastName,
          password: password
        })
        .then(() => {
          commit("loading", false, { root: true });
        })
        .catch(err => {
          commit("loading", false, { root: true });
          throw err;
        });
    },
    emailExists({ commit, state }, { email }) {
      flink.user.getEmail({ email: email }).then(r => {
        if (r) return true;
        return false;
      });
    },
    login({ commit, state }, { email, password }) {
      commit("loading", true, { root: true });
      return flink.session
        .login({
          email: email,
          password: password
        })
        .then(result => {
          commit("loading", false, { root: true });
          return result;
        })
        .catch(err => {
          commit("loading", false, { root: true });
          throw err;
        });
    },
    logout({ commit, state }) {
      commit("loading", true, { root: true });
      return flink.session
        .logout({})
        .then(() => {
          commit("loading", false, { root: true });
        })
        .catch(err => {
          commit("loading", false, { root: true });
          throw err;
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/users.js